import { render, staticRenderFns } from "./FreeVersionDesktopPlug.vue?vue&type=template&id=7d37f7d3&"
import script from "./FreeVersionDesktopPlug.vue?vue&type=script&lang=js&"
export * from "./FreeVersionDesktopPlug.vue?vue&type=script&lang=js&"
import style0 from "./FreeVersionDesktopPlug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports